<script setup lang="ts">
import type { CheckboxRootEmits, CheckboxRootProps } from 'reka-ui'
import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from 'reka-ui'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'

const props = defineProps<CheckboxRootProps>()
const emits = defineEmits<CheckboxRootEmits>()
const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <CheckboxRoot
    v-bind="forwarded"
    class="hover:bg-green-10 text-green-40 border-green-40 flex size-5 shrink-0 appearance-none items-center justify-center rounded-sm border-2 bg-white transition-colors outline-none focus-visible:ring"
  >
    <CheckboxIndicator class="flex h-full w-full items-center justify-center rounded">
      <font-awesome-icon
        :icon="faCheck"
        size="sm"
      />
    </CheckboxIndicator>
  </CheckboxRoot>
</template>
